goog.provide('el8.uiwidget.ClickItem');

goog.require('el8.template.uiwidget.ClickItem');
goog.require('el8.util.consts');
goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.service.infoField');


/**
 * This widget interacts with the mindreader to convert selected entries
 * into pretty divs, which can be clicked to edit again. (A typical mindreader
 * will leave the selected items as text in a text field).
 *
 * The ordering of selection/change events between the mindreader and here can be
 * tricky, but generally mindreader selects and changes should all fire before
 * any clickitem selects and changes. If you want to block clickitem activity on
 * mindreader activity, you currently have to avoid async ajax calls.
 *
 * You will generally use by passing clickItemOpts into a field spec
 * in the Form.
 *
 * See the physician autocomplete in letters (letters/form.js) /
 * the immunization dialog (addEditImmunization.js) for example usages.
 */
el8.uiwidget.ClickItem = function(opts) {

    opts = opts || {};

    /* Required - all ClickItems have a mindreader */
    this._mindreaderOpts = opts.mindreaderOpts;

    /* Basic opts */
    this._maxLength = opts.maxLength || null;
    this._infoText = opts.infoText || null;
    this._height = opts.height || null;
    this._name = opts.name || null;

    /* More opts */
    this._changeFn = opts.changeFn || null;
    this._clickDisplayEltFn = opts.clickDisplayEltFn || {};

    /* Display/item manipulation */
    this._getItemIdFn = opts.getItemIdFn || function(o) { return o.id || null; }; // whether item chosen from autocomplete or not
    this._formatSelectedItem = opts.formatSelectedItem || function(o) { return o; };
    this._formatManualItem = opts.formatManualItem || function(o) { return '(MANUAL) '+o.freeText; };

    /* Holds state */
    this._isEditMode = false;
    this._isInit = false;
};

el8.uiwidget.ClickItem.prototype.init = function(spec) {

    if (this._isInit) { return; }
    this._isInit = true;

    spec = spec || {};
    this._parentElt = spec.elt;
    var initItem = spec.initItem || null;

    this._contentElt = $(el8.template.uiwidget.ClickItem.content({
        spellcheck: el8.util.consts.SPELLCHECK,
        maxLength: this._maxLength,
        name: this._name
    }));
    this._parentElt.html(this._contentElt);

    this._hasTextareaWrap = this._parentElt.hasClass('el8TextareaWrap');

    this._displayElt = $('.ci-display', this._contentElt);
    this._editSectionElt = $('.ci-section', this._contentElt);
    this._editElt = $('.ci-edit', this._contentElt);

    if (this._infoText) {
        this._infoField = el8.service.infoField.addInfoField({
            field: this._editElt,
            infoText: this._infoText
        });
    }

    if (this._height) { this._editSectionElt.height(this._height); }
    this._editElt.height(el8.util.consts.DEFAULT_FIELD_HEIGHT).css('width', '100%');

    var that = this;

    var origSelectFn = this._mindreaderOpts['selectFn'];
    this._mindreaderOpts['selectFn'] = function(e, selectedItem, mr) {
        if (origSelectFn) { origSelectFn(e, selectedItem, mr); }
        that._setDisplayItem(selectedItem);
    };

    var origHideFn = this._mindreaderOpts['hideFn'];
    this._mindreaderOpts['hideFn'] = function() {
        if (origHideFn) { origHideFn(); }
        that._updateDisplay();
    };

    this._mindreaderOpts['focusAfterSelect'] = false;
    this._mindreaderOpts['showOnFocus'] = true;
    this._mindreaderOpts['minQueryLength'] = 0;
    this._mindreader = (new el8.uiwidget.NewMindreader(this._mindreaderOpts)).init(this._editElt);

    this._displayElt.on('click', function(e) {
        var $target = $(e.target);
        if ($target.hasClass('ci-remove-trigger')) {
            that.reset();
        } else {
            that._setEditMode();
        }
        that.focusField();
    });

    // Initialize in edit mode
    this._setEditMode();
    if (initItem) { this.setItem(initItem); }

    return this;
};

el8.uiwidget.ClickItem.prototype._setDisplayItem = function(item) {
    var $innerElt = null;
    if (!this._getItemIdFn(item)) {
        this._manualItem = item;
        $innerElt = $(this._formatManualItem(item));
        this._displayElt.html($innerElt);
    } else {
        this._manualItem = null;
        $innerElt = $(this._formatSelectedItem(item));
        this._displayElt.html($innerElt);
    }
    /* Bind triggers if any */
    if (this._clickDisplayEltFn) {
        $innerElt.on('click', this._clickDisplayEltFn);
    }

    this._displayElt.append($(el8.template.uiwidget.ClickItem.removeTrigger()));
    this._setDisplayMode();
    if (this._changeFn) { this._changeFn(item); }
};

el8.uiwidget.ClickItem.prototype._updateDisplay = function() {
    var selectedItem = this.getItem();

    /* If we don't have a selected item, format the text a particular way */
    if (!selectedItem && this._getTextVal()) {
        this._setDisplayItem({
            id: null,
            freeText: this._getTextVal()
        });
    }

    // TODO seems like this could be in an "else". check later..
    this._setDisplayMode();
};

el8.uiwidget.ClickItem.prototype.setItem = function(item, noTrigger) {
    this._mindreader.setSelectedItem(null, item, noTrigger);
    /* This willl call all the triggers and selectFn to display item properly */
};

el8.uiwidget.ClickItem.prototype.setFreeText = function(val) { // TODO do we need to support a trigger/noTrigger?
    this._infoField ? this._infoField.setVal(val) : this._editElt.val(val);
    this._setDisplayItem({
        id: null,
        freeText: val
    });
};

el8.uiwidget.ClickItem.prototype.getItem = function() {
    return this._mindreader.getSelectedItem();
};

/* Returns an ID if available and text otherwise */
el8.uiwidget.ClickItem.prototype.getItemVal = function() {
    var item = this._mindreader.getSelectedItem();
    return item ? this._getItemIdFn(item) : this._getTextVal();
};

el8.uiwidget.ClickItem.prototype.getItemId = function() {
    var item = this._mindreader.getSelectedItem();
    return item ? this._getItemIdFn(item) : null;
};

el8.uiwidget.ClickItem.prototype.reset = function() {
    this._infoField ? this._infoField.setVal('') : this._editElt.val('');
    this._clearItem();
    this._editElt.change();
    this._setEditMode();
};

el8.uiwidget.ClickItem.prototype.clearMindreaderCache = function() {
    this._mindreader.clearCache();
};

el8.uiwidget.ClickItem.prototype.hideMindreader = function() {
    this._mindreader.hide();
};

el8.uiwidget.ClickItem.prototype.focusField = function() {
    this._editElt.focusFocus();
};

el8.uiwidget.ClickItem.prototype._getTextVal = function() {
    return this._infoField ? this._infoField.getVal() : this._editElt.val();
};

el8.uiwidget.ClickItem.prototype._clearItem = function() {
    this._manualItem = null;
    this._displayElt.empty();
    this._mindreader.selectedItem = null; // calling setSelectedItem here will trigger an infinite loop
    this._mindreader.hide();
    if (this._changeFn) { this._changeFn(null); }
};

el8.uiwidget.ClickItem.prototype._setEditMode = function() {
    if (this._isEditMode) { return; }

    this._isEditMode = true;
    if (this._hasTextareaWrap) { this._parentElt.addClass('el8TextareaWrap').removeClass('el8NoPaddingWrap'); }
    this._displayElt.hide();
    this._editSectionElt.show();
    this._editElt.scrollintoview();
};

el8.uiwidget.ClickItem.prototype._setDisplayMode = function() {

    /* If text field is empty, don't go to display mode; nothing to show! */
    var val = this._getTextVal();
    if (!val) {
        this._clearItem();
        return;
    }

    this._isEditMode = false;
    if (this._hasTextareaWrap) { this._parentElt.removeClass('el8TextareaWrap').addClass('el8NoPaddingWrap'); }
    this._displayElt.show();
    this._editSectionElt.hide();

};

el8.uiwidget.ClickItem.prototype.isEditMode = function() {
    return this._isEditMode;
};
